import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, FeatureState } from './create-tray-screen.reducer';

const featureSelector = createFeatureSelector<FeatureState>(featureKey);

export const selectLoading = createSelector(featureSelector, (state) => state.loading);

export const selectCxbPageItem = createSelector(featureSelector, (state) => state.pageItem);

export const selectCurrentCategory = createSelector(featureSelector, (state) => state.selectedCategory);

export const selectCurrentTrayType = createSelector(featureSelector, (state) => state.selectedTrayType);
